<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Pregled evidence opravljenega prostovoljskega dela</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <Loading :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="false"></Loading>

                <!--                {{volunteerWorkHoursReports}}-->

                <b-form-group
                        label="Nastavi iskalne filtre"
                        label-for="month"
                >

                    <div class="row">

                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-3">
                                    <v-select
                                            v-model="month"
                                            placeholder="mesec"
                                            id="month"
                                            name="month"
                                            label="name"
                                            :reduce="item => item.id"
                                            :options="[
                                {id: 1, name: 'januar'},
                                {id: 2, name: 'februar'},
                                {id: 3, name: 'marec'},
                                {id: 4, name: 'april'},
                                {id: 5, name: 'maj'},
                                {id: 6, name: 'junij'},
                                {id: 7, name: 'julij'},
                                {id: 8, name: 'avgust'},
                                {id: 9, name: 'september'},
                                {id: 10, name: 'oktober'},
                                {id: 11, name: 'november'},
                                {id: 12, name: 'december'}
                            ]"
                                            @input="retrieveVolunteerWorkHoursReports"
                                    >

                                        <span slot="no-options">Ni zadetkov.</span>

                                    </v-select>
                                </div>
                                <div class="col-md-3">
                                    <v-select
                                            v-model="year"
                                            placeholder="leto"
                                            id="year"
                                            name="month"
                                            label="name"
                                            :reduce="item => item.id"
                                            :options="[
                                {id: 2018, name: '2018'},
                                {id: 2019, name: '2019'},
                                {id: 2020, name: '2020'},
                                {id: 2021, name: '2021'},
                                {id: 2022, name: '2022'},
                                {id: 2023, name: '2023'},
                                {id: 2024, name: '2024'},
                                {id: 2025, name: '2025'},
                                {id: 2026, name: '2026'},
                            ]"
                                            @input="retrieveVolunteerWorkHoursReports"
                                    >

                                        <span slot="no-options">Ni zadetkov.</span>

                                    </v-select>
                                </div>

                                <div class="col-md-3">
                                    <b-form-input
                                            id="municipality"
                                            name="municipality"
                                            v-model="municipality"
                                            placeholder="občina"
                                            @blur="retrieveVolunteerWorkHoursReports"
                                            trim></b-form-input>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <v-select
                                            v-model="project"
                                            placeholder="projekt"
                                            id="project"
                                            name="project"
                                            multiple
                                            :options="projects"
                                            label="name"
                                            :reduce="item => item.id"
                                            @input="retrieveVolunteerWorkHoursReports"
                                    >

                                        <span slot="no-options">Ni zadetkov.</span>
                                        <template slot="option" slot-scope="item">
                                            {{item.name}}
                                        </template>
                                        <template slot="selected-option" slot-scope="item">
                                            {{item.name}}
                                        </template>


                                    </v-select>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-3">

                        </div>

                    </div>
                </b-form-group>

                <div class="row">
                    <div class="col-md-9">
                        <vue-good-table
                                styleClass="vgt-table table table-hover table-striped"
                                :columns="columns"
                                :rows="volunteerWorkHoursReports"
                                :search-options="{
                                                        enabled: false,

                                                        placeholder: 'vnesi iskalni pojem',
                                                    }"
                                :sort-options="{
                                                        enabled: false,
                                                      }">

                            <div slot="emptystate">
                                <div class="text-center text-muted font-weight-light"><i
                                        class="fa fa-exclamation-triangle"></i>
                                    <em>Ni podatkov.</em></div>
                            </div>

                            <template slot="table-row" slot-scope="props">

                                <span v-if="props.column.field == 'createdAt'">
                                    {{props.index+1}}
                                </span>

                                <span v-if="props.column.field == 'date'">
                                    {{moment.unix(props.row.date.seconds).format('DD. MM. YYYY')}}
                                </span>

                                <span v-else-if="props.column.field == 'userId'">
                                    {{getReadableUser(props.row.userId)}}
                                </span>

                                <span v-else-if="props.column.field == 'isOrganizationalWork'">
                                    <div v-if="props.row.isOrganizationalWork"><i class="fas fa-check-circle"></i> {{props.row.organizationalWorkHours + ':' + props.row.organizationalWorkMinutes}}</div>
                                    <div v-if="!props.row.isOrganizationalWork"><i
                                            class="far fa-circle disabled"></i></div>
                                </span>

                                <span v-else-if="props.column.field == 'isDomainWork'">
                                    <div v-if="props.row.isDomainWork"><i class="fas fa-check-circle"></i> {{props.row.domainWorkHours + ':' + props.row.domainWorkMinutes}}</div>
                                    <div v-if="!props.row.isDomainWork"><i class="far fa-circle disabled"></i></div>
                                </span>

                                <span v-else-if="props.column.field == 'isOtherWork'">
                                    <div v-if="props.row.isOtherWork"><i class="fas fa-check-circle"></i> {{props.row.otherWorkHours + ':' + props.row.otherWorkMinutes}}</div>
                                    <div v-if="!props.row.isOtherWork"><i class="far fa-circle disabled"></i></div>
                                </span>

                                <span v-else-if="props.column.field == 'municiplaity'">
                                    {{props.row.municipality}}
                                </span>

                                <span v-else-if="props.column.field == 'id'">


                                        <b-dropdown variant="primary" text="Akcije" size="sm" boundary="body" right>
                                            <b-dropdown-item>
                                                <router-link
                                                        :to="{ name: 'AdminEditVolunteerWorkHoursReport', params: {id: props.row.id, readonly: true }}"
                                                        class="btn btn-info btn-sm btn-block mb-1 text-white">
                                        <i class="fa fa-eye"></i> Poglej</router-link>
                                            </b-dropdown-item>
                                            <b-dropdown-item>
                                                 <router-link
                                                         :to="{ name: 'AdminEditVolunteerWorkHoursReport', params: {id: props.row.id, readonly: false }}"
                                                         class="btn btn-primary btn-sm btn-block mb-1 text-white">
                                        <i class="fa fa-edit"></i> Uredi</router-link>
                                            </b-dropdown-item>
                                            <b-dropdown-item>
                                                         <a class="btn btn-warning btn-sm btn-block mb-1 text-white"
                                                            @click="duplicateWorkHourReportConfirmation(props.row)"><i
                                                                 class="fa fa-copy"></i> Podvoji</a>
                                            </b-dropdown-item>
                                            <b-dropdown-item>
                                                         <a class="btn btn-danger btn-sm btn-block mb-1 text-white"
                                                            @click="deleteWorkHourReportConfirmation(props.row)"><i
                                                                 class="fa fa-trash"></i> Odstrani</a>
                                            </b-dropdown-item>
                                        </b-dropdown>


<!--                                    <router-link-->
<!--                                            :to="{ name: 'EditVolunteerWorkHoursReport', params: {id: props.row.id, readonly: true }}"-->
<!--                                            class="btn btn-info btn-sm btn-block mb-1 text-white">-->
<!--                                        <i class="fa fa-eye"></i> Poglej</router-link>-->

<!--                                    <router-link-->
<!--                                            :to="{ name: 'EditVolunteerWorkHoursReport', params: {id: props.row.id, readonly: false }}"-->
<!--                                            class="btn btn-primary btn-sm btn-block mb-1 text-white">-->
<!--                                        <i class="fa fa-edit"></i> Uredi</router-link>-->

<!--                                    <a class="btn btn-danger btn-sm btn-block mb-1 text-white"-->
<!--                                       @click="deleteWorkHourReportConfirmation(props.row)"><i-->
<!--                                            class="fa fa-trash"></i> Odstrani</a>-->
                                </span>

                            </template>
                        </vue-good-table>

                        <router-link :to="{ name: 'EditVolunteerWorkHoursReport' }" class="btn btn-success mt-4">
                            <i class="fa fa-plus"></i> Dodaj zapis v evidenco prostovoljskega dela
                        </router-link>

                    </div>
                    <div class="col-md-3">
                        <a class="btn btn-primary text-white btn-block mb-2" @click="generatePdf"><i
                                class="fas fa-file-pdf"></i> Prenesi poročilo</a>

                        <div class="alert alert-info">
                            <dl class="row mb-0">
                                <dt class="col-sm-8"><small>Organizacijsko delo</small></dt>
                                <dd class="col-sm-4 text-right">{{organizationalWorkTotal}}</dd>

                                <dt class="col-sm-8"><small>Vsebinsko delo</small></dt>
                                <dd class="col-sm-4 text-right">{{domainWorkTotal}}</dd>

                                <dt class="col-sm-8"><small>Drugo delo</small></dt>
                                <dd class="col-sm-4 text-right">{{otherWorkTotal}}</dd>

                                <dt class="col-sm-12">
                                    <hr class="mt-0 mb-1"/>
                                </dt>

                                <dt class="col-sm-6 mb-0">Skupaj</dt>
                                <dd class="col-sm-6 mb-0 text-right">{{volunteerWorkTotal}}</dd>
                            </dl>
                        </div>

                    </div>
                </div>


            </div>
        </div>

    </div>

</template>

<script>
  import firebase from 'firebase'
  import {db} from '../../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import {add} from 'timelite/time'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'VolunteerWorkHoursReport',
    components: {
      VueGoodTable,
      Loading,
      vSelect
    },
    data () {
      return {
        isLoading: false,
        month: parseInt(this.moment().month() + 1),
        year: parseInt(this.moment().year()),
        municipality: '',
        projects: this.$store.getters.getProjects,
        project: null,
        selectedUser: JSON.parse(sessionStorage.getItem('DP_user')).id,
        users: this.$store.getters.getUsers,
        volunteerWorkHoursReports: [],
        monthAndYear: new Date(),
        columns: [
          {
            label: '#',
            field: 'createdAt',
            type: 'text',
            sortable: false,
          },
          {
            label: 'Datum',
            field: 'date',
            type: 'text',
            sortable: false,
          },
          {
            label: 'Prostovoljec',
            field: 'userId',
            type: 'text',
            sortable: false,
          },
          {
            label: 'Organizacijsko',
            field: 'isOrganizationalWork',
            type: 'text',
            sortable: false,
          },
          {
            label: 'Vsebinsko',
            field: 'isDomainWork',
            type: 'text',
            sortable: false,
          },
          {
            label: 'Drugo',
            field: 'isOtherWork',
            type: 'text',
            sortable: false,
          },
          {
            label: 'Občina',
            field: 'municiplaity',
            type: 'text',
            sortable: false,
          },
          {
            label: 'Akcije',
            field: 'id',
            type: 'text',
            sortable: false,
          }
        ],
        organizationalWorkTotal: '0:0',
        domainWorkTotal: '0:0',
        otherWorkTotal: '0:0',
        volunteerWorkTotal: '0:0',

        organizationalWorkValueTotal: 0,
        domainWorkValueTotal: 0,
        otherWorkValueTotal: 0,
        volunteerWorkValueTotal: 0,

        volunteerWorkHoursReport: {
          id: '',
          userId: '',
          date: null,
          isPartOfaProject: true,
          project: null,
          otherActivityDescription: '',
          addressName: '',
          municipality: '',

          isOrganizationalWork: false,
          organizationalWorkHours: '0',
          organizationalWorkMinutes: '0',
          organizationalWorkNotes: '',

          isDomainWork: false,
          domainWorkHours: '0',
          domainWorkMinutes: '0',
          domainWorkNotes: '',

          isOtherWork: false,
          otherWorkHours: '0',
          otherWorkMinutes: '0',
          otherWorkNotes: '',

          createdBy: '',
          createdAt: null,
          updatedBy: '',
          updatedAt: null
        },

      }
    },
    mounted () {
      const _this = this

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

      if (_this.$store.getters.getProjects.length === 0) {
        _this.$store.dispatch('retrieveProjects').then(() => {
          _this.projects = _this.$store.getters.getProjects
        })
      }

      _this.retrieveVolunteerWorkHoursReports()

    },
    methods: {

      generatePdf () {
        const _this = this

        let doc = new jsPDF()
        let body = []
        let userId = ''
        let month = _this.moment.months(_this.month - 1)

        _this.volunteerWorkHoursReports.forEach(function (report, i) {
          console.log(report)
          userId = report.userId
          console.log(userId)

          body.push([
            i + 1, _this.moment.unix(report.date.seconds).format('DD. MM. YYYY'), _this.getReadableUser(report.userId), (report.isOrganizationalWork ? report.organizationalWorkHours + ':' + report.organizationalWorkMinutes : '/'), (report.isDomainWork ? report.domainWorkHours + ':' + report.domainWorkMinutes : '/'), (report.isOtherWork ? report.otherWorkHours + ':' + report.otherWorkMinutes : '/'), report.municipality.replace('č', 'c')
          ])
        })

        month = _this.month ? month + ' ' : ''
        let year = _this.year ? _this.year : ''

        doc.autoTable({
          theme: 'plain',
          tableWidth: 'wrap',
          margin: {top: 15},
          head: [[_this.getReadableUser(userId) + ', ' + month + year + ':\nEvidenca prostovoljskega dela']],
          body: [],
        })

        doc.autoTable({
          tableWidth: 'wrap',
          margin: {top: 10},
          head: [['tip', 'ure (H:M)']],
          body: [
            ['Organizacijsko delo', _this.organizationalWorkTotal],
            ['Vsebinsko delo', _this.domainWorkTotal],
            ['Drugo delo', _this.otherWorkTotal],
            ['SKUPAJ', _this.volunteerWorkTotal]
          ],
        })

        doc.autoTable({
          margin: {top: 45},
          head: [['#', 'Datum', 'Prostovoljec', 'Organizacijsko', 'Vsebinsko', 'Drugo', 'Obcina']],
          body: body,
        })

        doc.save((year ? year + '_' : '') + (_this.month ? _this.month + '_' : '') + 'evidenca_prostovoljskega_dela_' + _this.getReadableUser(userId).replace(' ', '_') + '.pdf')

      },
      retrieveVolunteerWorkHoursReports () {
        const _this = this

        _this.organizationalWorkTotal = '0:0'
        _this.domainWorkTotal = '0:0'
        _this.otherWorkTotal = '0:0'
        _this.volunteerWorkTotal = '0:0'

        _this.isLoading = true

        let workHourReports = db.collection('volunteerWorkHoursReports')



        workHourReports
          .get()
          .then(querySnapshot => {

            let dbResults = querySnapshot.docs.map(doc => doc.data())
            _this.volunteerWorkHoursReports = dbResults

            if (_this.selectedUser) {
              _this.volunteerWorkHoursReports = _.filter(_this.volunteerWorkHoursReports, {'userId': _this.selectedUser})
            }

            if (_this.year) {
              _this.volunteerWorkHoursReports = _.filter(_this.volunteerWorkHoursReports, function (item) {
                if (_this.year === parseInt(_this.moment.unix(item.date.seconds).format('YYYY'))) {
                  return true
                } else {
                  return false
                }
              })
            }

            if (_this.month) {
              _this.volunteerWorkHoursReports = _.filter(_this.volunteerWorkHoursReports, function (item) {

                console.log('HERE')
                console.log(_this.month - 1)
                console.log(parseInt(_this.moment.unix(item.date.seconds).format('MM')))

                if (_this.month === parseInt(_this.moment.unix(item.date.seconds).format('MM'))) {
                  return true
                } else {
                  return false
                }
              })
            }

            if (_this.municipality) {
              _this.volunteerWorkHoursReports = _.filter(_this.volunteerWorkHoursReports, function (item) {
                if (_this.municipality.toLowerCase().replace(' ', '') === item.municipality.toLowerCase().replace(' ', '')) {
                  return true
                } else {
                  return false
                }
              })
            }

            if (_this.project) {
              _this.volunteerWorkHoursReports = _.filter(_this.volunteerWorkHoursReports, function (item) {

                // console.log(_this.project)
                let isMatch = false

                _.each(_this.project, function (val, key) {
                  console.log('val', val)
                  console.log('item', item)

                  if (item.project && item.project.indexOf(val) >= 0) {
                    console.log('item.project.indexOf(val)', item.project.indexOf(val))
                    isMatch = true
                  }
                })

                return isMatch

              })
            }

            _this.volunteerWorkHoursReports = _.sortBy(_this.volunteerWorkHoursReports, function(item) {
              return _this.moment.unix(item.date.seconds).toDate();
            });

            _this.calculateTotals()
            _this.isLoading = false
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.log('Error getting documents: ', error)
            _this.isLoading = false
          })

      },

      calculateTotals () {
        const _this = this

        _.each(_this.volunteerWorkHoursReports, function (val, key) {

          if (val.isOrganizationalWork) {
            _this.organizationalWorkTotal = add([_this.organizationalWorkTotal, val.organizationalWorkHours + ':' + val.organizationalWorkMinutes])[0] + ':' + add([_this.organizationalWorkTotal, val.organizationalWorkHours + ':' + val.organizationalWorkMinutes])[1]
          } else if (val.isDomainWork) {

            _this.domainWorkTotal = add([_this.domainWorkTotal, val.domainWorkHours + ':' + val.domainWorkMinutes])[0] + ':' + add([_this.domainWorkTotal, val.domainWorkHours + ':' + val.domainWorkMinutes])[1]

          } else if (val.isOtherWork) {
            _this.otherWorkTotal = add([_this.otherWorkTotal, val.otherWorkHours + ':' + val.otherWorkMinutes])[0] + ':' + add([_this.otherWorkTotal, val.otherWorkHours + ':' + val.otherWorkMinutes])[1]
          }
          //_this.volunteerWorkTotal = add([_this.organizationalWorkTotal, _this.domainWorkTotal + _this.otherWorkTotal])[0] + ':' + add([_this.organizationalWorkTotal, _this.domainWorkTotal + _this.otherWorkTotal])[1]
          let volunteerWorkTotal = add([_this.organizationalWorkTotal,  _this.domainWorkTotal, _this.otherWorkTotal]);
          _this.volunteerWorkTotal = volunteerWorkTotal[0] + ':' + volunteerWorkTotal[1];

          _this.organizationalWorkValueTotal = (parseInt(_this.organizationalWorkTotal.split(':')[0]) * 13) + (parseInt(_this.organizationalWorkTotal.split(':')[1]) / 60 * 13)
          _this.domainWorkValueTotal = (parseInt(_this.domainWorkTotal.split(':')[0]) * 10) + (parseInt(_this.domainWorkTotal.split(':')[1]) / 60 * 10)
          _this.otherWorkValueTotal = (parseInt(_this.otherWorkTotal.split(':')[0]) * 6) + (parseInt(_this.otherWorkTotal.split(':')[1]) / 60 * 6)

          _this.volunteerWorkValueTotal = _this.organizationalWorkValueTotal + _this.domainWorkValueTotal + _this.otherWorkValueTotal

        })

      },

      getOptionLabel (option) {
        //console.log(option);
        return this.getReadableUser(option.id)
      },

      duplicateWorkHourReportConfirmation(data) {
        const _this = this

        console.log(data);

        _this.volunteerWorkHoursReport = data;

        let ref = db.collection('volunteerWorkHoursReports').doc()
        ref.set({id: ref.id}) // set new document ID
          .then(() => {  // fetch the doc again and show its data
            ref.get().then(doc => {

              const document = doc.data();

              _this.id = document.id;

              _this.volunteerWorkHoursReport = data;
              _this.volunteerWorkHoursReport.id = document.id;
              _this.volunteerWorkHoursReport.date = new Date();
              _this.volunteerWorkHoursReport.createdAt = new Date();
              _this.volunteerWorkHoursReport.createdBy = JSON.parse(sessionStorage.getItem('DP_user')).id;

              console.log(_this.volunteerWorkHoursReport);

              _this.updateWorkHoursReport()

            })
          })

      },

      updateWorkHoursReport (id) {
        const _this = this
        const currentWorkHoursReport = db.collection('volunteerWorkHoursReports').doc(this.id)

        this.$validator.validate().then(result => {
          if (result) {
            return currentWorkHoursReport.update(_this.volunteerWorkHoursReport)
              .then(function () {
                _this.retrieveVolunteerWorkHoursReports();
              })
              .catch(function (error) {
                // The document probably doesn't exist.
                console.error('Error updating work hour report: ', error)
              })
          } else {
            _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
          }
        })

      },

      deleteWorkHourReportConfirmation (data) {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati evidenco za dan ' + _this.moment.unix(data.date.seconds).format('DD. MM. YYYY') + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteWorkHourReport(data.id)

              case null:

                return

                break

              default:

            }
          })
      },
      deleteWorkHourReport (id) {
        const _this = this
        _this.isLoading = true
        db.collection('volunteerWorkHoursReports').doc(id).delete()
          .then(function () {
            _this.isLoading = false
            _this.retrieveVolunteerWorkHoursReports()
            //_this.$router.push({name: 'WorkHoursReport'})
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting project: ', error)
          })
      },
      getReadableUser (userId) {
        const _this = this

        console.log(userId)

        let userObj = _.filter(_this.users, {'id': userId})[0]
        return userObj.first_name + ' ' + userObj.last_name

      },
      setMonthFilter () {
        const _this = this
        _this.month = _this.month
        console.log(_this.month)
      },
      setYearFilter () {
        console.log(_this.year)
      },

      getReadableUser (userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/VolunteerWorkHoursReport.vue